export class UnitDisplay {
  private symbol: string;
  private position: 'before' | 'after';

  constructor(options: {
    locale: string;
    unit: string;
    unitDisplay: 'long' | 'short' | 'narrow';
  });
  constructor(options: {
    locale: string;
    currency: string;
    currencyDisplay: 'code' | 'symbol';
  });
  constructor({
    locale,
    currency,
    currencyDisplay,
    unit,
    unitDisplay,
  }: {
    locale: string;
    currency?: string;
    currencyDisplay?: 'code' | 'symbol';
    unit?: string;
    unitDisplay?: 'long' | 'short' | 'narrow';
  }) {
    let formatter: Intl.NumberFormat;
    let type: 'currency' | 'unit';
    if (currency) {
      type = 'currency';
      formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay,
      });
    } else if (unit) {
      type = 'unit';
      formatter = new Intl.NumberFormat(locale, {
        style: 'unit',
        unit,
        unitDisplay,
      });
    } else {
      throw new Error('Either currency or unit must be provided');
    }
    const parts = formatter.formatToParts(1000);
    this.symbol = parts.find((part) => part.type === type)?.value ?? '';
    this.position =
      parts.findIndex((part) => part.type === type) <
      parts.findIndex((part) => part.type === 'integer')
        ? 'before'
        : 'after';
  }

  get prefix() {
    return this.position === 'before' ? this.symbol : null;
  }

  get suffix() {
    return this.position === 'after' ? this.symbol : null;
  }
}
